import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
const VerticalImageGalleryContext = createContext({});
export const VerticalImageGalleryProvider = ({ children }) => {
    const [activeTab, setActiveTab] = useState(undefined);
    const value = {
        activeTab,
        setActiveTab,
    };
    return (_jsx(VerticalImageGalleryContext.Provider, Object.assign({}, { value }, { children: children })));
};
export const useVerticalImageGallery = () => {
    const context = useContext(VerticalImageGalleryContext);
    return context;
};
//# sourceMappingURL=VerticalImageGalleryProvider.js.map